import React, {Component} from 'react';
import './style.scss';
import {Point} from "../../../types";
import {getLocalBounds} from "../../../utils";

interface IProps {
    refs: ForResizeType[],
    resizeHandler: any
}

export type ForResizeType = {
    ref: React.RefObject<HTMLElement>,
    h?: boolean,
    w?: boolean,
    w100?: boolean
}


type StartParams = {
    width: number,
    height: number
}

type Params = {
    startParams: StartParams,
    startPoint: Point
} | null;

type ResizeType = 'TOP' | 'LEFT' | 'TOPLEFT'

interface IState {
    wrapperRef: Node,
    dragged: boolean,
    params: Params[],
    startPoint: Point[] | null,
    resizer: ResizeType
}

class ResizerComponent extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.onDragStart= this.onDragStart.bind(this);
        this.onDragMove = this.onDragMove.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mouseup', this.handleClickOutside);
        document.addEventListener('mousemove', this.onDragMove);
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.handleClickOutside);
        document.removeEventListener('mousemove', this.onDragMove);
    }

    setWrapperRef(node: Node| null) {
        if(node) this.setState({wrapperRef: node});
    }

    handleClickOutside(event: any) {
        if (this.state.wrapperRef && !this.state.wrapperRef.contains(event.target)) {
            this.onDragEnd(event)
        }
    }

    onDragStart = (e: React.MouseEvent) => {
        let resizeType: ResizeType;
        switch (e.currentTarget.className) {
            case 'top-resizer': 
                resizeType = 'TOP';
                break;
            case 'left-resizer':
                resizeType = 'LEFT';
                break;
            default:
                resizeType = 'TOPLEFT'
        }
                
        this.setState({
            resizer: resizeType
          });

        const params = this.props.refs.map(({ref}: ForResizeType) => {
            const elem = ref.current;

            if (elem) {
                const { width, height } = getLocalBounds(elem);

                return {
                    startParams: {width: width, height},
                    startPoint: {x: e.clientX, y: e.clientY}
                }
            } else return null
        });

        this.setState({params, dragged: true})

        document.body.classList.add('noSelect');
    };

    onDragMove = (e: any) => {
        if (!this.state.dragged) return;

        this.props.refs.map(({ref, h, w}: ForResizeType, i: number) => {
            const elem = ref.current;
            if (elem && this.state.params[i]) {
                //@ts-ignore
                const {startParams, startPoint} = this.state.params[i];
                const {x, y} = startPoint;
                const {width, height} = startParams;

                if (elem) {
                    if (w && e.clientX >= 15 && this.state.resizer !== 'TOP') elem.style.width = width + x - e.clientX + 'px';
                    if (h && e.clientY >= 25 && this.state.resizer !== 'LEFT') elem.style.height = height + y - e.clientY + 'px';
                }
            }
        });


        const el = document.getElementsByClassName('export-status__content')[0];
        //@ts-ignore
        el.style.width = '100%'
    };

    onDragEnd = (e: React.MouseEvent) => {
        if (this.state.dragged) this.setState({
            dragged: false
        });

        document.body.classList.remove('noSelect');
        const elem: any = this.props.refs[0].ref.current;
        elem && this.props.resizeHandler(elem.style.width.substring(0, elem.style.width.length - 2), elem.style.height.substring(0, elem.style.height.length - 2));
    };

    onDoubleClick = (e: React.MouseEvent) => {
        const elem: any = this.props.refs[0].ref.current;
        elem.removeAttribute('style');
        elem && this.props.resizeHandler(elem.style.width.substring(0, elem.style.width.length - 2), elem.style.height.substring(0, elem.style.height.length - 2));    }

   render() {
       return (
           <div className='resizer-component'>
            <div className='resizer'
                ref={this.setWrapperRef}
                onMouseDown={this.onDragStart}
                onMouseUp={this.onDragEnd}
                onDoubleClick={this.onDoubleClick}
            >⇱</div>
            <div className="top-resizer" 
                onMouseDown={this.onDragStart}
                onMouseUp={this.onDragEnd}
            ></div>
            <div className="left-resizer" 
                onMouseDown={this.onDragStart}
                onMouseUp={this.onDragEnd}
            ></div>
           </div>
       )
   }
};


// this.props.refs.map((ref) => {
//     const elem = ref.current;
//     if (elem) {
//         const { width, height } = getLocalBounds(elem);
//
//         this.setState({
//             startParams: {width, height},
//             startPoint: {x: e.clientX, y: e.clientY}
//         });
//     }
// })

export default ResizerComponent;